import * as React from 'react';

import {Button} from '../button/button';
import {FooterBar} from '../modal/footer-bar';
import {ModalSubheader} from '../typography/modal-subheader';

import {FileUpload} from './file-upload';

import styles from './file-upload-modal-page.module.css';

type Props = {
    subheaderText?: React.ReactNode;
    isUnsubscribe?: boolean;
    audienceId?: string;
};

export function FileUploadModalPage(props: Props) {
    const [file, setFile] = React.useState<any>(null);

    return (
        <>
            {props.subheaderText ? (
                <ModalSubheader as='div'>{props.subheaderText}</ModalSubheader>
            ) : undefined}
            <form
                method='post'
                encType='multipart/form-data'
                action='/setup/import-account-contact-csv/upload'
                className={styles.form}
            >
                <FileUpload
                    accept='.csv,.xls,.xlsb,.xlsx,.xlr,.wks,.numbers,.ods,.sxc'
                    name='qqfile' // This is required for our CSV import
                    id='file'
                    maxFileSize='10MB'
                    onChange={setFile}
                    enableDropping={true}
                />
                {props.isUnsubscribe ? (
                    <input type='hidden' name='unsubscribe' value='1' />
                ) : undefined}
                {props.audienceId ? (
                    <input type='hidden' name='audienceId' value={props.audienceId.split('-')[0]} />
                ) : undefined}
                <FooterBar
                    right={
                        <Button type='submit' disabled={!file} variant='primary' size='big'>
                            Next
                        </Button>
                    }
                />
            </form>
        </>
    );
}
